import { graphql } from '@search/gql-client/src';

export const OfferQuery = graphql`query OfferQuery(
    $offerId: String!,
    $skipNotMain: Boolean!
) {
    mortgageBannerMinutesVariant: randomNumber(from: 0, to: 2) {
        value
    }
    mortgageBannerTextVariant: randomNumber(from: 0, to: 1) {
        value
    }
    userDetails {
        userId
        phone
    }
    offer(id: $offerId) {
        __typename
        ... on ProfOfferError {
            message
        }
        ... on ProfOfferSnippet {
            id
            isNewBuildingPaid
            stats @skip(if: $skipNotMain) {
                isViewed
                all {
                    offerViews
                }
                today {
                    offerViews
                }
            }
            description
            isFavorite @skip(if: $skipNotMain)
            noteText @skip(if: $skipNotMain)
            hasSubscription @skip(if: $skipNotMain)
            isHidden @skip(if: $skipNotMain)
            isFavoriteVisible
            isMortgageAllowed
            mortgagePurpose
            text {
                slug
                titleSnippet
                titleCard
                titleBuildingSavedSearch
                metaTitle
                metaDescription
                pageDescription
            }
            dealType {
                __typename
                ... on ProfOfferDealSell {
                    price {
                        value
                        currency
                        areaUnit
                        rubPrice
                        history {
                            valueRub
                            diff {
                                rub
                            }
                            date2 {
                                iso
                                formattedFull
                            }
                        }
                        valuePerAreaUnitRub
                    }
                    hasBankPledge
                    sellType
                    sellTypeFormatted
                    bargainAllowed {
                        formatted
                    }
                    mortgageAllowed
                }
                ... on ProfOfferDealRent {
                    commission {
                        formatted
                    }
                    bargainAllowed {
                        formatted
                    }
                    price {
                        value
                        currency
                        areaUnit
                        rubPrice
                        history {
                            valueRub
                            diff {
                                rub
                            }
                            date2 {
                                iso
                                formattedFull
                            }
                        }
                    }
                    period
                    utilities {
                        formatted
                    }
                    livingTenantRequirements {
                        childrenAllowed {
                            formatted
                        }
                        petsAllowed {
                            formatted
                        }
                    }
                    hasPrepayment {
                        formatted
                    }
                    hasDeposit {
                        formatted
                    }
                }
            }
            gallery {
                baseUrl
                mainImage {
                    originPath
                    attributesType
                }
                images {
                    originPath
                    attributesType
                }
            }
            status {
                isDeleted
                createdActualizeFormatted
                visibility
                cluster {
                    id
                    tailSize
                }
                hasAnyPriority
                hasTop
                hasHighlight
                vas {
                    valueCase
                }
            }
            infrastructure {
                parking {
                    type
                }
                hasConcierge
                hasGuardedArea
            }
            realtyObject {
                __typename
                ... on ProfOfferFlat {
                    flatType
                    totalArea {
                        formatted
                        value
                        unit
                    }
                    kitchenArea {
                        formatted
                        value
                        unit
                    }
                    livingArea {
                        formatted
                    }
                    roomsCount
                    roomType
                    floor
                    isApartments
                    livingFacilities {
                        hasAirConditioner
                        hasDishwasher
                        hasFridge
                        hasFurniture
                        hasInternet
                        hasInternet
                        hasKitchenFurniture
                        hasTv
                        hasWashingMachine
                    }
                    characteristics {
                        hasBalcony
                        ceilingHeightM
                        bathroomType
                        bathroomCount
                        renovationType
                        nbFinishingType {
                            type
                            text
                        }
                        windowsDirection
                    }
                    building {
                        buildingId
                        newBuildingId
                        isNewbuilding
                        floorsTotal
                        wallsType
                        hasLift
                        newBuildingBasicInfo {
                            title
                            slug
                        }
                        newBuildingStatus {
                            formattedInProgress
                            builtYear
                        }
                    }
                }
                ... on ProfOfferRoom {
                    roomCount
                    livingArea {
                        formatted
                        value
                        unit
                    }
                    roomsLivingAreaFormatted
                    enclosingFlat {
                        flatType
                        totalArea {
                            formatted
                            value
                            unit
                        }
                        kitchenArea {
                            formatted
                            value
                            unit
                        }
                        livingArea {
                            formatted
                        }
                        roomsCount
                        roomType
                        floor
                        livingFacilities {
                            hasAirConditioner
                            hasDishwasher
                            hasFridge
                            hasFurniture
                            hasInternet
                            hasInternet
                            hasKitchenFurniture
                            hasTv
                            hasWashingMachine
                        }
                        characteristics {
                            hasBalcony
                            ceilingHeightM
                            bathroomType
                            renovationType
                            nbFinishingType {
                                type
                                text
                            }
                            windowsDirection
                        }
                        building {
                            isNewbuilding
                            buildingId
                            floorsTotal
                            wallsType
                            hasLift
                            newBuildingStatus {
                                formattedInProgress
                                builtYear
                            }
                        }
                    }
                }
                ... on ProfOfferHouse {
                    category2 {
                        formatted
                        value
                    }
                    totalArea {
                        value
                        unit
                        formatted
                    }
                    livingFacilities {
                        hasAirConditioner
                        hasDishwasher
                        hasFridge
                        hasFurniture
                        hasInternet
                        hasInternet
                        hasKitchenFurniture
                        hasTv
                        hasWashingMachine
                    }
                    floorsTotal
                    builtYear
                    hasBathroom
                    bathroomLocationType
                    hasHeating
                    heatingType
                    land {
                        area {
                            value
                            unit
                            formatted
                        }
                        supply {
                            hasGas
                            hasWater
                            hasElectricity
                            hasSewerage
                        }
                        status
                        status2 {
                            value
                            formatted
                        }
                    }
                    roomsCount
                }
                ... on ProfOfferLand {
                    area {
                        value
                        unit
                        formatted
                    }
                    supply {
                        hasGas
                        hasWater
                        hasElectricity
                        hasSewerage
                    }
                    status2 {
                        value
                        formatted
                    }
                }
            }
            badges {
                isRgrMember
            }
            location {
                formattedAddressLong
                cityCenterInfo {
                    metersToCentralSquare
                    locatedInCenter
                }
                clickableAddress {
                    id
                    translit
                    name
                    kind
                }
                formattedAddressShort
                narrowRegion {
                    id
                    name
                }
                wideDistrict {
                    id
                    translit
                    name
                }
                narrowDistrict {
                    id
                    translit
                    name
                }
                locality {
                    id
                    translit
                    name
                }
                street {
                    id
                    translit
                    name
                }
                house {
                    id
                    translit
                    name
                }
                coordinates {
                    latitude
                    longitude
                }
                routesList {
                    ... on RouteMetro {
                        timeMinutes
                        transportType
                        station {
                            id
                            name
                            allRoutesColorsList
                        }
                    }
                }
                isMskMO
                isSPbLO
            }
            seller {
                ownerId
                name
                organizationName
                organizationNameFull
                sellerType
                logo {
                    preview2
                    origin
                }
                isZhekaLogo
                placementUserId
                mainPhone {
                    countryCode
                    number
                    hiddenSuffixLength
                    formattedNumber
                }
                phoneList {
                    countryCode
                    number
                    hiddenSuffixLength
                    formattedNumber
                }
            }
            related @skip(if: $skipNotMain) {
                id
                isNewBuildingPaid
                description
                noteText
                isFavorite
                isFavoriteVisible
                isMortgageAllowed
                text {
                    titleSnippet
                    titleCard
                    slug
                }
                stats {
                    isViewed
                }
                dealType {
                    __typename
                    ... on ProfOfferDealSell {
                        price {
                            value
                            currency
                            areaUnit
                            rubPrice
                            history {
                                valueRub
                                diff {
                                    rub
                                }
                                date2 {
                                    iso
                                    formattedFull
                                }
                            }
                        }
                        hasBankPledge
                        sellType
                        bargainAllowed {
                            formatted
                        }
                        mortgageAllowed
                    }
                    ... on ProfOfferDealRent {
                        commission {
                            formatted
                        }
                        bargainAllowed {
                            formatted
                        }
                        price {
                            value
                            currency
                            areaUnit
                            rubPrice
                            history {
                                valueRub
                                diff {
                                    rub
                                }
                                date2 {
                                    iso
                                    formattedFull
                                }
                            }
                        }
                        period
                        utilities {
                            formatted
                        }
                        livingTenantRequirements {
                            childrenAllowed {
                                formatted
                            }
                            petsAllowed {
                                formatted
                            }
                        }
                        hasPrepayment {
                            formatted
                        }
                        hasDeposit {
                            formatted
                        }
                    }
                }
                gallery {
                    baseUrl
                    mainImage {
                        originPath
                        attributesType
                        small
                    }
                    images {
                        originPath
                        attributesType
                    }
                }
                status {
                    isDeleted
                    createdAt {
                        formattedAutoDate
                    }
                    actualizedAt {
                        formattedAutoDate
                    }
                    visibility
                    cluster {
                        id
                        tailSize
                    }
                    hasAnyPriority
                    hasTop
                    hasHighlight
                    vas {
                        valueCase
                    }
                }
                infrastructure {
                    parking {
                        type
                    }
                }
                realtyObject {
                    __typename
                    ... on ProfOfferFlat {
                        flatType
                        totalArea {
                            formatted
                            value
                            unit
                        }
                        kitchenArea {
                            formatted
                            value
                            unit
                        }
                        livingArea {
                            formatted
                        }
                        roomsCount
                        roomType
                        floor
                        livingFacilities {
                            hasAirConditioner
                            hasDishwasher
                            hasFridge
                            hasFurniture
                            hasInternet
                            hasInternet
                            hasKitchenFurniture
                            hasTv
                            hasWashingMachine
                        }
                        characteristics {
                            hasBalcony
                            ceilingHeightM
                            bathroomType
                            bathroomCount
                            renovationType
                            nbFinishingType {
                                type
                                text
                            }
                            windowsDirection
                        }
                        building {
                            isNewbuilding
                            buildingId
                            floorsTotal
                            wallsType
                            newBuildingStatus {
                                builtYear
                            }
                            newBuildingBasicInfo {
                                title
                                slug
                            }
                        }
                    }
                    ... on ProfOfferRoom {
                        roomCount
                        livingArea {
                            formatted
                            value
                            unit
                        }
                        enclosingFlat {
                            flatType
                            totalArea {
                                formatted
                                value
                                unit
                            }
                            kitchenArea {
                                formatted
                                value
                                unit
                            }
                            livingArea {
                                formatted
                            }
                            roomsCount
                            roomType
                            floor
                            livingFacilities {
                                hasAirConditioner
                                hasDishwasher
                                hasFridge
                                hasFurniture
                                hasInternet
                                hasInternet
                                hasKitchenFurniture
                                hasTv
                                hasWashingMachine
                            }
                            characteristics {
                                hasBalcony
                                ceilingHeightM
                                bathroomType
                                renovationType
                                nbFinishingType {
                                    type
                                    text
                                }
                                windowsDirection
                            }
                            building {
                                buildingId
                                isNewbuilding
                                floorsTotal
                                wallsType
                                newBuildingStatus {
                                    builtYear
                                }
                            }
                        }
                    }
                    ... on ProfOfferHouse {
                        category2 {
                            formatted
                            value
                        }
                        totalArea {
                            value
                            unit
                            formatted
                        }
                        livingFacilities {
                            hasAirConditioner
                            hasDishwasher
                            hasFridge
                            hasFurniture
                            hasInternet
                            hasInternet
                            hasKitchenFurniture
                            hasTv
                            hasWashingMachine
                        }
                        floorsTotal
                        builtYear
                        hasBathroom
                        bathroomLocationType
                        hasHeating
                        heatingType
                        land {
                            area {
                                formatted
                            }
                            supply {
                                hasGas
                                hasWater
                                hasElectricity
                                hasSewerage
                            }
                            status
                        }
                        roomsCount
                    }
                    ... on ProfOfferLand {
                        area {
                            value
                            unit
                            formatted
                        }
                        supply {
                            hasGas
                            hasWater
                            hasElectricity
                            hasSewerage
                        }
                        status
                    }
                }
                badges {
                    isRgrMember
                }
                location {
                    formattedAddressLong
                    cityCenterInfo {
                        metersToCentralSquare
                        locatedInCenter
                    }
                    clickableAddress {
                        id
                        translit
                        name
                        kind
                    }
                    formattedAddressShort
                    clickableAddressShort {
                        id
                        translit
                        name
                        kind
                    }
                    narrowRegion {
                        id
                        name
                    }
                    wideDistrict {
                        id
                        translit
                        name
                    }
                    narrowDistrict {
                        id
                        translit
                        name
                    }
                    locality {
                        id
                        translit
                        name
                    }
                    street {
                        id
                        translit
                        name
                    }
                    house {
                        id
                        translit
                        name
                    }
                    coordinates {
                        latitude
                        longitude
                    }
                    routesList {
                        ... on RouteMetro {
                            timeMinutes
                            transportType
                            station {
                                id
                                name
                                allRoutesColorsList
                            }
                        }
                    }
                }
                seller {
                    ownerId
                    name
                    organizationName
                    sellerType
                    logo {
                        preview2
                        origin
                    }
                    isZhekaLogo
                    mainPhone {
                        countryCode
                        number
                        hiddenSuffixLength
                        formattedNumber
                    }
                    phoneList {
                        countryCode
                        number
                        hiddenSuffixLength
                        formattedNumber
                    }
                }
                newBuildingCard {
                    ranking
                    buildings {
                        id
                        address
                    }
                }
            }
            similarNb {
                __typename
                id
                location {
                    formattedAddressLong
                    formattedAddressShort
                    clickableAddress {
                        id
                        translit
                        name
                        kind
                    }
                    clickableAddressShort {
                        id
                        translit
                        name
                        kind
                    }
                    narrowRegion {
                        id
                        name
                    }
                    locality {
                        id
                        translit
                        name
                    }
                    routesList {
                        ... on RouteMetro {
                            timeMinutes
                            transportType
                            station {
                                id
                                name
                                allRoutesColorsList
                            }
                        }
                    }
                }
                dealType {
                    __typename
                    ... on ProfOfferDealSell {
                        price {
                            value
                            rubPrice
                            formatted
                            currency
                            areaUnit
                        }
                    }
                }
                gallery {
                    baseUrl
                    mainImage {
                        originPath
                        preview1
                        preview2
                        small
                        attributesType
                    }
                    images {
                        originPath
                        preview1
                        preview2
                        medium
                        small
                        large
                        attributesType
                    }
                }
                text {
                    titleSnippet
                    slug
                }
                realtyObject {
                    __typename
                    ... on ProfOfferFlat {
                        building {
                            buildingId
                            newBuildingBasicInfo {
                                title
                            }
                            newBuildingStatus {
                                formattedInProgress
                                isKeysComingSoonBadge
                                isDoneBadge
                            }
                        }
                    }
                }
            }
            buildingRelated @skip(if: $skipNotMain) {
                title
                list {
                    id
                    text {
                        slug
                        titleCard
                        titleSnippetMini
                    }
                    location {
                        narrowRegion {
                            id
                        }
                    }
                    dealType {
                        __typename
                        ... on ProfOfferDealSell {
                            price {
                                value
                                currency
                                areaUnit
                                rubPrice
                                formatted
                            }
                        }
                        ... on ProfOfferDealRent {
                            price {
                                value
                                currency
                                areaUnit
                                rubPrice
                                formattedWithCurrency
                            }
                        }
                    }
                    gallery {
                        baseUrl
                        mainImage {
                            originPath
                            attributesType
                        }
                    }
                }
            }
            renovationProgram
            buildingSeries
            buildEpoch
            heatingType
            infrastructureEntitiesList
            yardEntityList
            onlineView
            newBuildingCard {
                year
                title {
                    nominative
                    locative
                    genitive
                }
                seo {
                    seoTitle
                }
                buildingClass {
                    value
                    fullLabel
                }
                buildingStatus {
                    title
                    isFrozen
                    isCommissioned
                }
                gallery {
                    baseUrl
                    main {
                        large
                        originPath
                    }
                }
                ranking
                address
                isMskMO
                isSPbLO
                hasChat
                buildings {
                    id
                    address
                    commissioningDate
                    commissioningYear
                }
                developerCards {
                    developer {
                        isSamolet
                        title
                        url
                    }
                }
                routeParams {
                    region
                    regionId
                    subRegion
                    type
                    name
                    id
                }
                flats {
                    label(type: SNIPPET)
                    isSoldOut
                    isSoon
                    isTemporaryNotOnSale
                    priceMin
                }
                news {
                    title
                    link
                    categories {
                        label
                    }
                    images
                    date {
                        formattedShort
                    }
                }
                specialEvents {
                    type
                    title
                    titleRaw
                    description {
                        short
                        full
                    }
                    duration {
                        short
                        full
                    }
                    buildingIds
                    isHighlighted
                }
            }
            ratedSchools
            fromCian
        }
    }
}
`;
